//
// Copyright (c) 2011-2024 by Curalate, Inc
//

import React from 'react';

import HR from '@components/atoms/hr/HR';
import { CollapsibleSection } from '@components/media-filters/CollapsibleSection';
import { DropdownFilter } from '@components/media-filters/DropdownFilter';
import {
  FilterSection,
  FilterSectionTitle,
} from '@components/media-filters/filterSectionModels';

export const DEFAULT_PRODUCT_TAGS_FILTER_SECTION: FilterSection<boolean> = {
  options: [
    { isSelected: false, value: true, label: 'Has product tags' },
    { isSelected: false, value: false, label: "Doesn't have product tags" },
  ],
  paramKey: 'hasProducts',
};

export interface ProductTagsFilterProps {
  isDisabled?: boolean;
  isInitiallyCollapsed?: boolean;
  section: FilterSection<boolean> | undefined;
  onChange: (section: FilterSection<boolean>) => void;
}

export const ProductTagsFilter = ({
  isDisabled,
  isInitiallyCollapsed,
  section = DEFAULT_PRODUCT_TAGS_FILTER_SECTION,
  onChange,
}: ProductTagsFilterProps) => (
  <>
    <CollapsibleSection
      isCollapsed={isInitiallyCollapsed}
      title={FilterSectionTitle[section.paramKey]}
    >
      <DropdownFilter
        isDisabled={isDisabled}
        placeholder='Not specified'
        section={section}
        onChange={onChange}
      />
    </CollapsibleSection>

    <HR />
  </>
);
